import React, { useState, useEffect, useRef } from 'react';
import validationErrors from '@/lib/validationErrors';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getTableBySlugPagesService } from '@/services/PagesServices';

const FrontCmsPage = () => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [dataSource, setDataSource] = useState({});
    const { slug } = useParams();

    useEffect(() => {
        if (slug && slug != '') {
            getDataBySlug(slug);
        }
    }, [slug]);

    const getDataBySlug = (slug) => {
        setIsLoading(true);
        dispatch(getTableBySlugPagesService(slug))
            .then((res) => {
                console.log({ response: res?.data?.data });
                setDataSource(res?.data?.data);
                setIsLoading(false);
            })
            .catch(({ message, errorData, statusCode }) => {
                validationErrors(errorData, message);
                setIsLoading(false);
            });
    };

    return (
        <section className="py-14 px-4 w-full max-w-3xl mx-auto">
            <div className="">
                <a id="logo-home-route" href="/home" className="block mx-auto w-36 mb-8">
                    <img className="w-full" src={'/assets/images/theme/theme-logo.png'} alt="logo" />
                </a>
                <h3 className="text-[22px] text-center font-medium leading-[34px] mb-6">{dataSource?.title}</h3>
            </div>
            <div className="">{dataSource?.description}</div>
        </section>
    );
};

export default FrontCmsPage;
